import styled from 'styled-components';
import HappyPayAtHotelNewSvg from './happyPayAtHotelNew.svg';

const HappyPayAtHotelNewIcon = styled(
  HappyPayAtHotelNewSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  margin: ${props => props.margin};
  fill: ${props => props.fill || props.theme.colors.downriver.medium};
  cursor: pointer;
`;

export default HappyPayAtHotelNewIcon;
